import { Skeleton } from '@braskai/ui-kit';

import { Box, Stack } from '@mui/material';

const SKELETONS_ITEMS = Array.from({ length: 5 }, (_, index) => index + 1);

export const EditGlossarySkeletons = () => {
  return (
    <Stack gap={24} padding="24px 24px 0">
      <Box
        sx={{
          display: 'grid',
          gap: 8,
          gridTemplateColumns: '1fr 1fr 64px',
        }}
      >
        <Stack gap={8}>
          <Skeleton borderRadius={4} height={20} variant="rectangular" width="50%" />
          <Skeleton borderRadius={8} height={40} variant="rectangular" width="100%" />
          <Skeleton borderRadius={4} height={18} variant="rectangular" width="60%" />
        </Stack>

        <Stack gap={8}>
          <Skeleton borderRadius={4} height={20} variant="rectangular" width="50%" />
          <Skeleton borderRadius={8} height={40} variant="rectangular" width="100%" />
        </Stack>

        <Skeleton borderRadius={8} height={40} sx={{ alignSelf: 'center' }} variant="rectangular" width="100%" />
      </Box>

      <Stack gap={12}>
        {SKELETONS_ITEMS.map((item) => {
          return (
            <Box
              key={item}
              sx={(theme) => ({
                borderBottom: `1px solid ${theme.palette.grey[200]}`,
                display: 'grid',
                gap: 8,
                gridTemplateColumns: '1fr 1fr 64px',
                paddingBottom: 12,
              })}
            >
              <Skeleton borderRadius={4} height={22} variant="rectangular" width="100%" />
              <Skeleton borderRadius={4} height={22} variant="rectangular" width="100%" />
              <Skeleton borderRadius={4} height={22} sx={{ justifySelf: 'end' }} variant="rectangular" width={20} />
            </Box>
          );
        })}
      </Stack>
    </Stack>
  );
};
